'use client'

import LoadingScreen from '@/components/loading-screen'
import { useAuth } from '@/providers/AuthProvider'
import { routes } from '@/utils/routes'
import { Box, Container } from '@mui/system'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

export default function AuthGuard({ children }: React.PropsWithChildren) {
  const { isAuthenticated, isInitialized } = useAuth()
  const pathname = usePathname()
  const router = useRouter()
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null)

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      if (pathname !== requestedLocation) {
        setRequestedLocation(pathname)
      }
      router.push(routes.authLogin)
    }
  }, [isInitialized, isAuthenticated, pathname, requestedLocation, router])

  useEffect(() => {
    if (isAuthenticated && requestedLocation && pathname !== requestedLocation) {
      router.push(requestedLocation)
      setRequestedLocation(null)
    }
  }, [isAuthenticated, requestedLocation, pathname, router])

  if (!isInitialized) {
    return (
      <Container>
        <Box sx={{ width: '100%', marginTop: 4 }}>
          <LoadingScreen />
        </Box>
      </Container>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
}
